import { ErrorMessage } from "formik";
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";

const CustomFlatpickr = ({
  field: { name, value },
  form: { setFieldValue },
  label,
  required,
  placeholder,
  onChange,
  noMarginBottom,
  ...props
}) => {
  return (
    // <div className="mb-3">
    <div className={`${noMarginBottom == true ? "" : "mb-2"}`}>
      {label && (
        <label className="mb-1">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      <Flatpickr
        {...props}
        value={value}
        className="form-control form-control-sm"
        placeholder={placeholder}
        // onChange={([start]) => setFieldValue(name, start)}
        onChange={([start]) => {
          if (onChange) {
            onChange(start);
          } else {
            setFieldValue(name, start);
          }
        }}
      />
      <ErrorMessage
        name={name}
        component="div"
        className="invalid-feedback animated fadeInUp"
        style={{ display: "block" }}
      />
    </div>
  );
};

export default CustomFlatpickr;
